<ng-container *ngIf="hasViewAccess; else noMaintenanceAccess">
<div class="flex-container" style="display: flex;">
	<!-- Left Side -->
	<div class="maintenance-block" style="flex: 1; padding-right: 10px; border-right: 1px solid #ccc;">
		<h5 class="card-title">Maintenance Scheduler</h5>
		<p *ngIf="!canEdit">You can view this maintenance configuration, but you do not have permission to edit it.</p>
		<div class="custom-form" [formGroup]="maintenanceForm">
			<div style="width: 100%">
				<label class="form-label">Start date maintenance</label>
				<dx-date-box formControlName="enableMaintenanceModeFrom" displayFormat="dd/MM/yyyy HH:mm" type="datetime" placeholder="Select start date"></dx-date-box>

				<label class="form-label">End date maintenance</label>
				<dx-date-box formControlName="enableMaintenanceModeTo" displayFormat="dd/MM/yyyy HH:mm" type="datetime" placeholder="Select end date"></dx-date-box>
				<small class="form-text text-muted">If you want to prematurely end the maintenance window, please set the end date to a value in the past. This will allow the system to re-schedule the link based on the existing configuration.</small>
				<small class="form-text text-muted">Setting the end date to a value in the future will allow you to set a custom maintenance window. After this maintenance window the schedule will be resumed.</small>

				<label class="form-label">Start date message display</label>
				<dx-date-box formControlName="enableMaintenanceModeMessageFrom" displayFormat="dd/MM/yyyy HH:mm" type="datetime" placeholder="Select start date for message"></dx-date-box>
				<small class="form-text text-muted">By default calculated using the start date maintenance.</small>

				<label class="form-label">Short description</label>
				<dx-text-box formControlName="maintenanceModeMessageShort" placeholder="Enter short description"></dx-text-box>

				<label class="form-label">Long description</label>
				<dx-text-area formControlName="maintenanceModeMessageLong" placeholder="Enter long description"></dx-text-area>

				<label class="form-label">Recurrence rule</label>
				<dx-text-area formControlName="maintenanceModeRecurrenceRule" placeholder="Enter recurrence rule"></dx-text-area>
				<small class="form-text text-muted">Enter the recurrence pattern using iCalendar RFC 2445 format.</small>

				<label class="form-label">Recurrence rule exception</label>
				<dx-text-area formControlName="maintenanceModeRecurrenceRuleException" placeholder="Enter recurrence rule exception if applicable"></dx-text-area>

				<!-- <label class="form-label">Blocked applications during maintenance</label>
				<dx-list [dataSource]="applications$ | async" [(selectedItemKeys)]="selectedKeys" [height]="400" displayExpr="displayName" keyExpr="id" [selectionMode]="'all'" [showSelectionControls]="true"></dx-list> -->
				<label class="form-label">Blocked applications during maintenance</label>
				<ng-container *ngIf="applications$ | async as applications">
					<div class="select-buttons">
						<dx-button [disabled]="!canEdit" (onClick)="selectAll(applications)">Select All</dx-button>
						<dx-button [disabled]="!canEdit" (onClick)="deselectAll()">Deselect All</dx-button>
					</div>
					<dx-scroll-view>
						<div class="quick grid">
							<div class="card iconhover" *ngFor="let app of filter(applications)" (click)="addToFilter(app.id)" [class.selected]="selected(app.id)">
								<img title="{{app.displayName}}" style="width:auto; height:54px" [src]="getUrl('/application-logos/'+app.imageRef)" />
								<div class="app-name">{{app.name}}</div>
							</div>
						</div>
					</dx-scroll-view>
				</ng-container>
			</div>
			<br>
		</div>
		<button style="margin-bottom: 5px;" class="btn btn-primary btn-sm" [disabled]="!canEdit" (click)="saveMaintenance()">Save Maintenance</button>
	</div>

	<!-- Right Side -->
	<div class="right-block" style="flex: 1; padding-left: 10px;">
		<h5 class="card-title">Calender</h5>
		<div class="content-placeholder">
			<!-- Place your content here -->
			<dx-scheduler [showCurrentTimeIndicator]="true" [shadeUntilCurrentTime]="true" [timeZone]="companyTimezone" [dataSource]="appointments" [views]="['month']" currentView="month">
			</dx-scheduler>
		</div>
	</div>
</div>
</ng-container>

<ng-template #noMaintenanceAccess>
	<div class="maintenance-block">
		<h5 class="card-title">Maintenance Scheduler</h5>
		<p>You do not have access to the maintenance scheduler.</p>
	</div>
</ng-template>
